import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../../ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../../Util/axiosErrorHandler'
import { IAPICustomerExtend, ICustomer } from '../ICustomer'
import { customerTransformer } from '../transformer/customerTransformer'

export const fetchCustomerList = createAsyncThunk<
  ICustomer[],
  Record<string, never>,
  IThunkReject<any>
>('customerList/fetch', async (payload, { rejectWithValue }) => {
  let customerList: ICustomer[] = []

  try {
    const promise = clientSDK
      .instance()
      .get<{ customers: IAPICustomerExtend[] }>(
        `customers/search?limit=200&page=1&with_no_show_stats=false&keyword=`,
      )

    const result = await promise
    customerList = result.data.customers.map((customer: IAPICustomerExtend) =>
      customerTransformer(customer),
    )
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return customerList
})
